import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { useMemo } from 'react';
import SvgIcon from '../../SvgIcon';
import { ICON_SIZE, INFO_WITH_ICONS_SMALL_MARGIN } from '../../constants';
import { ELEMENT_GRAY } from '../../colors';
import { useMediaBreakpoints } from '../../hooks';
import InfoWithIconsSimple from '../InfoWithIcons/InfoWithIconsSimple';
import InfoContentSimple from './InfoContentSimple';

var InfoContentWithIconSimple = function InfoContentWithIconSimple(_ref) {
  var icon = _ref.icon,
      _ref$iconMargin = _ref.iconMargin,
      iconMargin = _ref$iconMargin === void 0 ? INFO_WITH_ICONS_SMALL_MARGIN : _ref$iconMargin,
      _ref$iconSize = _ref.iconSize,
      iconSize = _ref$iconSize === void 0 ? ICON_SIZE : _ref$iconSize,
      _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? ELEMENT_GRAY : _ref$iconColor,
      _ref$iconColorHover = _ref.iconColorHover,
      iconColorHover = _ref$iconColorHover === void 0 ? null : _ref$iconColorHover,
      _ref$iconTopPosition = _ref.iconTopPosition,
      iconTopPosition = _ref$iconTopPosition === void 0 ? 0 : _ref$iconTopPosition,
      lineHeight = _ref.lineHeight,
      props = _objectWithoutPropertiesLoose(_ref, ["icon", "iconMargin", "iconSize", "iconColor", "iconColorHover", "iconTopPosition", "lineHeight"]);

  var title = props.title,
      _props$lines = props.lines,
      linesProp = _props$lines === void 0 ? 1 : _props$lines,
      component = props.component;
  var lines = useMediaBreakpoints(linesProp);

  var _ref2 = /*#__PURE__*/React.createElement(SvgIcon, {
    size: iconSize,
    color: iconColor,
    colorHover: iconColorHover
  }, icon);

  var content = useMemo(function () {
    return title ? icon ? /*#__PURE__*/React.createElement(InfoWithIconsSimple, {
      fullWidth: true,
      fullInnerWidth: true,
      ellipsis: lines === 1,
      lineHeight: lineHeight,
      component: component,
      multiline: true,
      iconMargin: iconMargin,
      iconWidth: iconSize,
      iconTopPosition: iconTopPosition,
      icon: _ref2
    }, title || "\u200C") : title || "\u200C" : null;
  }, [title, icon, iconMargin, iconSize, iconColor, lineHeight, lines]);
  return /*#__PURE__*/React.createElement(InfoContentSimple, _extends({}, props, {
    title: content
  }));
};

export default InfoContentWithIconSimple;